function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M47.23 39.72a2 2 0 112-2 2 2 0 01-2 2zm-9-6.7v-4.38A8 8 0 1029.9 15a12 12 0 10-19.66 11.64v4.92a16 16 0 1122-21.64 12.47 12.47 0 012-.2 12 12 0 014 23.3zm-33 7.7a2 2 0 11-2 2 2 2 0 012.01-2zm10-17c0-1.11-.11-2 1-2s1 .89 1 2v24h-2a4 4 0 00-4-4v-2a6 6 0 014 1.55zm9 14c-1.11 0-1-.9-1-2v-8c0-1.11-.11-2 1-2s1 .89 1 2v8c.01 1.1.11 2-.99 2zm0 4a2 2 0 11-2 2 2 2 0 012.01-2zm8-20c1.11 0 1 .89 1 2v18a10 10 0 018-4v2a8 8 0 00-8 8h-2a7 7 0 01.05-.81 7.36 7.36 0 01-.05-1.19v-22c0-1.11-.1-2 1-2z"
});

var SvgSleet = function SvgSleet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 50.74 49.01",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSleet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sleet.631b9915.svg";
export { ForwardRef as ReactComponent };